"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-param-reassign */
var react_1 = __importStar(require("react"));
var is_hotkey_1 = __importDefault(require("is-hotkey"));
var slate_react_1 = require("slate-react");
var slate_1 = require("slate");
var core_1 = require("@21st-night/core");
var slate_history_1 = require("slate-history");
var EditorToolbar_1 = __importDefault(require("./components/EditorToolbar"));
var EditorHoveringToolbar_1 = __importDefault(require("./components/EditorHoveringToolbar"));
var EditorElement_1 = __importDefault(require("./components/EditorElement"));
var EditorLeaf_1 = __importDefault(require("./components/EditorLeaf"));
var helpers_1 = require("./helpers");
var ExtractTextFromImageDialogContainer_1 = __importDefault(require("./containers/ExtractTextFromImageDialogContainer"));
var withLinks_1 = __importDefault(require("./plugins/withLinks"));
var HOTKEYS = {
    'mod+b': 'bold',
    'mod+i': 'italic',
    'mod+u': 'underline',
};
var withMediaEmbed = function (editor) {
    var normalizeNode = editor.normalizeNode;
    editor.focus = function () {
        slate_react_1.ReactEditor.focus(editor);
        try {
            var lastElement = editor.children[editor.children.length - 1];
            if (lastElement) {
                var lastChild = lastElement.children[lastElement.children.length - 1];
                if (lastChild.type) {
                    lastChild = lastChild.children[lastChild.children.length - 1];
                }
                var path = slate_react_1.ReactEditor.findPath(editor, lastChild);
                slate_1.Transforms.select(editor, {
                    anchor: { path: path, offset: lastChild.text.length },
                    focus: { path: path, offset: lastChild.text.length },
                });
            }
        }
        catch (err) {
            console.log(err);
        }
    };
    editor.normalizeNode = function (entry) {
        var e_1, _a;
        var _b = __read(entry, 2), node = _b[0], path = _b[1];
        // If the element is a paragraph, ensure it's children are valid.
        if (slate_1.Element.isElement(node) && node.type === 'insert-image-link') {
            try {
                // eslint-disable-next-line no-restricted-syntax
                for (var _c = __values(slate_1.Node.children(editor, path)), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var _e = __read(_d.value, 2), child = _e[0], childPath = _e[1];
                    if (slate_1.Element.isElement(child)) {
                        slate_1.Transforms.unwrapNodes(editor, { at: childPath });
                        return;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        var needsNewline = slate_1.Element.isElement(node) &&
            [
                'media',
                'image-uploaded',
                'image-linked',
                'insert-image-link',
                'insert-image-upload',
                'insert-image-phone',
            ].includes(node.type);
        // If the element is void, ensure it's followed by an editable node.
        if (needsNewline) {
            var prevPath = __spreadArray(__spreadArray([], __read(path.slice(0, -1))), [path.slice(-1)[0] - 1]);
            var nextPath = __spreadArray(__spreadArray([], __read(path.slice(0, -1))), [path.slice(-1)[0] + 1]);
            if (!slate_1.Node.has(editor, prevPath) ||
                !slate_1.Element.isElement(slate_1.Node.get(editor, prevPath)) ||
                editor.isVoid(slate_1.Node.get(editor, prevPath))) {
                slate_1.Transforms.insertNodes(editor, {
                    type: 'paragraph',
                    children: [{ text: '' }],
                }, { at: path });
                return;
            }
            if (!slate_1.Node.has(editor, nextPath) ||
                !slate_1.Element.isElement(slate_1.Node.get(editor, nextPath)) ||
                editor.isVoid(slate_1.Node.get(editor, nextPath))) {
                slate_1.Transforms.insertNodes(editor, {
                    type: 'paragraph',
                    children: [{ text: '' }],
                }, { at: nextPath });
            }
        }
        // Fall back to the original `normalizeNode` to enforce other constraints.
        normalizeNode(entry);
    };
    return editor;
};
var withHtml = function (editor) {
    var insertData = editor.insertData, isInline = editor.isInline;
    editor.isInline = function (element) {
        return element.type === 'link' ? true : isInline(element);
    };
    editor.insertData = function (data) {
        var html = data.getData('text/html');
        if (html) {
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var deserializedFragments = helpers_1.deserialize(parsed.body);
            var fragments_1 = [];
            if (deserializedFragments && Array.isArray(deserializedFragments)) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                // @ts-ignore
                deserializedFragments.forEach(function (fragment) {
                    if (fragment.text) {
                        var texts = fragment.text && fragment.text.split('\n');
                        texts.forEach(function (text) {
                            fragments_1.push({
                                type: fragment.type || 'paragraph',
                                children: [{ text: text || '' }],
                            });
                        });
                    }
                    else {
                        fragments_1.push(fragment);
                    }
                });
                fragments_1.forEach(function (fragment) {
                    if (!fragment.children ||
                        !fragment.children.length ||
                        fragment.children[0].text === '\n') {
                        fragment.children = [{ text: '' }];
                    }
                });
                slate_1.Transforms.insertFragment(editor, fragments_1);
            }
            return;
        }
        if (data.files && data.files.length) {
            slate_1.Transforms.insertNodes(editor, {
                type: 'insert-image-upload',
                children: [{ text: '' }],
                file: data.files.item(0),
            });
            return;
        }
        insertData(data);
    };
    return editor;
};
var withEmbeds = function (editor) {
    var isVoid = editor.isVoid, isInline = editor.isInline;
    editor.isVoid = function (element) {
        return [
            'media',
            'image-uploaded',
            'image-linked',
            'insert-image-link',
            'insert-image-upload',
            'insert-image-phone',
        ].includes(element.type)
            ? true
            : isVoid(element);
    };
    editor.isInline = function (element) {
        return element.type === 'link' ? true : isInline(element);
    };
    return editor;
};
var RichTextEditor = function (_a) {
    var _b = _a.disableToolbar, disableToolbar = _b === void 0 ? false : _b, _c = _a.disableHoveringToolbar, disableHoveringToolbar = _c === void 0 ? false : _c, _d = _a.initialValue, initialValueProp = _d === void 0 ? core_1.createEmptyDocument() : _d, placeholder = _a.placeholder, onChange = _a.onChange, onSelectionChange = _a.onSelectionChange, onClickCardLink = _a.onClickCardLink, onStartTyping = _a.onStartTyping, _e = _a.onChangeDebounce, onChangeDebounce = _e === void 0 ? 300 : _e, name = _a.name, _f = _a.autofocus, autofocus = _f === void 0 ? true : _f, _g = _a.selectionOnly, selectionOnly = _g === void 0 ? false : _g, _h = _a.updateFromInitialValue, updateFromInitialValue = _h === void 0 ? false : _h, simulateInputChangeEvent = _a.simulateInputChangeEvent, toolbar = _a.toolbar, _j = _a.plugins, pluginsProp = _j === void 0 ? [] : _j, _k = _a.Element, ElementProp = _k === void 0 ? EditorElement_1.default : _k, highlightCardLink = _a.highlightCardLink, minHeight = _a.minHeight, maxHeight = _a.maxHeight, children = _a.children, hideToolbarOnBlur = _a.hideToolbarOnBlur, saving = _a.saving, other = __rest(_a, ["disableToolbar", "disableHoveringToolbar", "initialValue", "placeholder", "onChange", "onSelectionChange", "onClickCardLink", "onStartTyping", "onChangeDebounce", "name", "autofocus", "selectionOnly", "updateFromInitialValue", "simulateInputChangeEvent", "toolbar", "plugins", "Element", "highlightCardLink", "minHeight", "maxHeight", "children", "hideToolbarOnBlur", "saving"]);
    var clearUploads = core_1.useUploads().clearUploads;
    var initialValue = typeof initialValueProp === 'string'
        ? JSON.parse(initialValueProp)
        : initialValueProp;
    var _l = __read(react_1.useState(__spreadArray(__spreadArray([
        withEmbeds,
        withMediaEmbed,
        withHtml,
        withLinks_1.default
    ], __read(pluginsProp)), [
        slate_history_1.withHistory,
    ])), 1), plugins = _l[0];
    var _m = __read(react_1.useState(false), 2), isTyping = _m[0], setIsTyping = _m[1];
    var _o = __read(react_1.useState(initialValue.filter(function (block) { return block.type !== 'insert-image-upload'; })), 2), value = _o[0], setValue = _o[1];
    var _p = __read(react_1.useState(false), 2), dirty = _p[0], setDirty = _p[1];
    var _q = __read(react_1.useState(false), 2), extractTextDialogOpen = _q[0], setExtractTextDialogOpen = _q[1];
    var _r = __read(react_1.useState(), 2), extractTextImage = _r[0], setExtractTextImage = _r[1];
    var renderElement = react_1.useCallback(function (props) { return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    react_1.default.createElement(ElementProp, __assign({}, props))); }, []);
    var renderLeaf = react_1.useCallback(function (props) { return (react_1.default.createElement(EditorLeaf_1.default, __assign({}, props, { highlightCardLink: highlightCardLink, onClickCardLink: onClickCardLink }))); }, [highlightCardLink, onClickCardLink]);
    var editor = react_1.useMemo(function () {
        return plugins.reduce(function (ed, plugin) {
            return plugin(ed);
        }, slate_react_1.withReact(slate_1.createEditor()));
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    react_1.useEffect(function () {
        clearUploads();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    react_1.useEffect(function () {
        if (!dirty && core_1.isEmpty(value) && !core_1.isEmpty(initialValue)) {
            setValue(initialValue);
        }
    }, [dirty, initialValue, value]);
    var debouncedValue = core_1.useDebounce(value, onChangeDebounce);
    react_1.useEffect(function () {
        var data = simulateInputChangeEvent
            ? {
                target: {
                    value: debouncedValue,
                    getAttribute: function () { return name || ''; },
                },
            }
            : debouncedValue;
        if (!dirty && !core_1.isEmpty(debouncedValue)) {
            setDirty(true);
        }
        setIsTyping(false);
        if (onChange) {
            onChange(data);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedValue]);
    react_1.useEffect(function () {
        if (updateFromInitialValue) {
            setValue(initialValue);
        }
    }, [initialValue, updateFromInitialValue]);
    function openExtractTextFromImageDialog(event) {
        if (event.target && event.target.files) {
            setExtractTextImage(event.target.files[0]);
            setExtractTextDialogOpen(true);
        }
    }
    react_1.useEffect(function () {
        if (autofocus) {
            editor.focus();
        }
        // eslint-disable-next-line
    }, []);
    return (react_1.default.createElement(slate_react_1.Slate, { editor: editor, value: value, onChange: function (value) {
            if (!selectionOnly) {
                setValue(value);
                if (!isTyping) {
                    setIsTyping(true);
                    if (onStartTyping) {
                        onStartTyping();
                    }
                }
            }
            else if (onSelectionChange) {
                onSelectionChange(editor.selection);
            }
        } },
        !disableToolbar && (react_1.default.createElement(EditorToolbar_1.default, { controls: toolbar, hideOnBlur: hideToolbarOnBlur, saving: saving, onOpenExtractTextFromImageDialog: openExtractTextFromImageDialog })),
        !disableHoveringToolbar && react_1.default.createElement(EditorHoveringToolbar_1.default, null),
        children,
        react_1.default.createElement(slate_react_1.Editable, __assign({ renderElement: renderElement, renderLeaf: renderLeaf, placeholder: placeholder, spellCheck: !selectionOnly, 
            // autoFocus={autofocus}
            style: {
                flex: 1,
                minHeight: minHeight || 200,
                maxHeight: maxHeight || 'auto',
                caretColor: selectionOnly ? 'transparent' : 'auto',
                overflow: 'auto',
            }, onKeyDown: function (event) {
                if (!selectionOnly) {
                    Object.keys(HOTKEYS).forEach(function (hotkey) {
                        if (is_hotkey_1.default(hotkey, event.nativeEvent)) {
                            event.preventDefault();
                            var mark = HOTKEYS[hotkey];
                            helpers_1.toggleMark(editor, mark);
                        }
                    });
                }
            } }, other)),
        extractTextDialogOpen && (react_1.default.createElement(ExtractTextFromImageDialogContainer_1.default, __assign({ open: extractTextDialogOpen, file: extractTextImage, onClose: function () { return setExtractTextDialogOpen(false); } }, other)))));
};
exports.default = RichTextEditor;
//# sourceMappingURL=RichTextEditor.js.map